import { render, staticRenderFns } from "./BecomeIBModal.vue?vue&type=template&id=6992471e&"
import script from "./BecomeIBModal.vue?vue&type=script&lang=js&"
export * from "./BecomeIBModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports